import {
    createSlice,
    createSelector,
    createAsyncThunk,
    createEntityAdapter
  } from '@reduxjs/toolkit';
  import { client } from '../../../../api/client';

  export const alertAdapter = createEntityAdapter();  
  const initialState = alertAdapter.getInitialState({
    status: 'idle',
    stack: [],
  });
  
  /*
    THUNK
  */
  export const showNextAlert = () => (dispatch, getState) => {
    const alerts = getState().alert.stack;

    if (alerts.length > 0) {
      dispatch(removeAlert());
    }
  };

  export const saveAlert = createAsyncThunk('alert/saveAlert', async form => {
    const saveAlertForm = { form };
    const response = await client.post('https://flashcards.dev418.com/api/v1/alerts/store', { payload: saveAlertForm.form?.formValues });
    return response.alert;
  });
  
  /*
    SLICE / REDUCER
  */
  
  const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
      addAlert: (state, action) => {
        state.stack.push(action.payload);
      },
      removeAlert: (state) => {
        state.stack.shift();
      }
    },
    extraReducers: builder => {
      builder
        .addCase(saveAlert.pending, (state, action) => {
            state.status = 'loading';
        })
        .addCase(saveAlert.fulfilled, (state, action) => {
            state.status = 'idle';
        })
    }
  });
  
  export const {
    addAlert,
    removeAlert
  } = alertSlice.actions;
  
  export default alertSlice.reducer;

  /*
    SELECTORS
  */
  
  export const { selectAll: selectAlerts, selectById: selectAlertById } =
  alertAdapter.getSelectors(state => state.alert)

  export const selectCurrentAlert = (state) => state.alert.stack[0];